var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1557bf",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h2v10H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4v2H0V4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plus-green.8c0dc7775f2821c1c1ba0721f526b321.svg";
export { ForwardRef as ReactComponent };